import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Matches from "@/pages/Matches";
import MatchDetail from "@/pages/MatchDetail";
import Standings from "@/pages/Standings";
import Predictions from "@/pages/Predictions";
import Teams from "@/pages/Teams";
import Privacy from "@/pages/Privacy";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nContext";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/matches" element={<Matches />} />
              <Route path="/matches/:id" element={<MatchDetail />} />
              <Route path="/standings" element={<Standings />} />
              <Route path="/predictions" element={<Predictions />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </Layout>
          <CookieBanner />
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </I18nProvider>
    </div>
  );
}

export default App;
